// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SwVgVtHHCnspHWNtfm9J{padding:0 24px 16px}.NdPVWf3D9iYKQRnFMO5p{padding-left:20px;padding-right:20px}.Vz386SJv1U0TMuKEjFNH{justify-content:space-between;gap:8px;width:100%;padding:8px 12px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"alert": `SwVgVtHHCnspHWNtfm9J`,
	"list": `NdPVWf3D9iYKQRnFMO5p`,
	"row": `Vz386SJv1U0TMuKEjFNH`
};
export default ___CSS_LOADER_EXPORT___;
